//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getMoment } from "../helpers/Functions";
export default {
  name: "Counter",
  props: {
    datetime: {
      required: true,
      type: String
    },
    second: {
      type: Boolean,
      default: true
    },
    minute: {
      type: Boolean,
      default: true
    },
    hour: {
      type: Boolean,
      default: true
    },
    day: {
      type: Boolean,
      default: true
    },
    month: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      timestamp: 0
    };
  },
  methods: {
    calcTime: function calcTime() {
      this.timestamp = new Date(this.datetime).getTime() - new Date(getMoment().format("YYYY-MM-DD HH:mm:ss")).getTime();

      if (this.timestamp <= 0) {
        this.timestamp = 0;
        this.clearTimer();
      }
    },
    startTimer: function startTimer() {
      var _this = this;

      this.calcTime();
      this.timer = setInterval(function () {
        _this.calcTime();
      }, 1000);
    },
    clearTimer: function clearTimer() {
      if (this.timer) clearInterval(this.timer);
    }
  },
  computed: {
    calculatedTime: function calculatedTime() {
      var timestamp = this.timestamp,
          second = this.second,
          minute = this.minute,
          hour = this.hour,
          day = this.day,
          month = this.month;
      var monthDifference;

      if (month) {
        monthDifference = Math.floor(timestamp / 1000 / 60 / 60 / 24 / 30);
        timestamp -= monthDifference * 1000 * 60 * 60 * 24 * 30;
      }

      var daysDifference;

      if (day) {
        daysDifference = Math.floor(timestamp / 1000 / 60 / 60 / 24);
        timestamp -= daysDifference * 1000 * 60 * 60 * 24;
      }

      var hoursDifference;

      if (hour) {
        hoursDifference = Math.floor(timestamp / 1000 / 60 / 60);
        timestamp -= hoursDifference * 1000 * 60 * 60;
      }

      var minutesDifference;

      if (minute) {
        minutesDifference = Math.floor(timestamp / 1000 / 60);
        timestamp -= minutesDifference * 1000 * 60;
      }

      var secondsDifference;

      if (second) {
        secondsDifference = Math.floor(timestamp / 1000);
      }

      var calculatedTime = {
        month: Math.round(monthDifference),
        day: Math.round(daysDifference),
        hour: Math.round(hoursDifference),
        minute: Math.round(minutesDifference),
        second: Math.round(secondsDifference)
      };

      for (var itm in calculatedTime) {
        if (isNaN(calculatedTime[itm])) calculatedTime[itm] = 0;

        if (calculatedTime[itm] < 10) {
          calculatedTime[itm] = "0" + calculatedTime[itm];
        }
      }

      return calculatedTime;
    }
  },
  mounted: function mounted() {
    this.startTimer();
  },
  destroyed: function destroyed() {
    this.clearTimer();
  }
};